export default function ResourceScreenMutator( type, plugin, molten ) {
  const { id } = plugin
  if (
    id != null &&
    ( ( id.startsWith( 'link.' ) && id.endsWith( '.Rsrcs' ) ) ||
  ( id.startsWith( 'route.' ) && id.endsWith( '.ResourceRsrcs' ) ) ) ) {
    return {
      ...plugin,
      matches : () => false
    }
  }
  return plugin
}
